'use es6';

import { getSenderTypeFromAgentType } from './getSenderTypeFromAgentType';
export const buildSenderObjectsFromAgentsResponse = (agents = []) => {
  return agents.map(agent => {
    const {
      avatar,
      userId,
      email,
      agentType,
      firstName,
      lastName
    } = agent;
    const senderType = getSenderTypeFromAgentType(agentType);
    return {
      avatar,
      email,
      firstName,
      id: userId,
      lastName,
      senderType
    };
  });
};